import React from 'react'
import formStyles from 'styles/form.module.scss'
import FullName from 'components/fields/registration/FullName'
import DateOfBirth from 'components/fields/registration/DateOfBirth'
import Religion from 'components/fields/registration/Religion'
import MotherTongue from 'components/fields/registration/Mothertongue'
import Location from 'components/fields/registration/Location'

const BasicDetails = props => {
  return (
    <>
      <h2 className={formStyles.formTitle}>Great! Now some basic details</h2>
      <FullName />
      <DateOfBirth />
      <Religion domainReligion={props.domainReligion} />
      <MotherTongue domainLanguage={props.domainLanguage} />
      <Location domainCountry={props.domainCountry} />
    </>
  )
}

export default BasicDetails
